(function() {
  var IGNORED_MESSAGES, filter,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  IGNORED_MESSAGES = ['Script error', 'Script error.'];

  filter = function(notice) {
    var msg;
    msg = notice.errors[0].message;
    if (indexOf.call(IGNORED_MESSAGES, msg) >= 0) {
      return null;
    }
    return notice;
  };

  module.exports = filter;

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./~/airbrake-js/lib/internal/default_filter.js
// module id = 813
// module chunks = 0